// GEN NAME AND DATA FILE
const genNameAndDateFile = file => `${file.lastModified}_${file.name}`;

// ALL EXPORTS
export { genNameAndDateFile };
